import type { ReactElement } from "react"
import AlignContentOrg from "@onestore/hel/dist/components/organisms/AlignContentOrg"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import _t from "@core/i18n"
import BaseContainer from "@gatsby-plugin-generic-page/components/BaseContainer"
import BaseSection from "@gatsby-plugin-generic-page/components/BaseSection"
import Header from "@gatsby-plugin-generic-page/components/Header"
import MarkdownText from "@gatsby-plugin-generic-page/components/Markdown/Text"
import { SquidexTableWithContentCellType } from "@gatsby-plugin-generic-page/fragments/tableWithContentRow"
import type { TableWithContentSectionFlatData } from "@gatsby-plugin-generic-page/fragments/tableWithContentSection"
import TableMolWrapper from "~/components/TableMolWrapper"
import isEmpty from "~/lib/isEmpty"

function TableWithContentSection({
  header,
  sectionSettings,
  table,
}: TableWithContentSectionFlatData): ReactElement<TableWithContentSectionFlatData> {
  const { label, columns, groups } = table

  const groupsData = groups.map(({ groupLabel, rows }) => {
    const rowsData = rows.map((row) => {
      return {
        label: row.label,
        values: row.values.map((value) => {
          if (
            SquidexTableWithContentCellType.TEXT === value.type &&
            !isEmpty(value.text)
          ) {
            return (
              <MarkdownText
                typographyBreakpoint={{
                  default: {
                    small: "nano2",
                    medium: "nano2",
                    large: "small3",
                  },
                  bold: {
                    small: "nano3",
                    medium: "nano3",
                    large: "small4",
                  },
                }}
                pushSpace={0}
              >
                {value.text}
              </MarkdownText>
            )
          }

          if (SquidexTableWithContentCellType.DEFAULT_ICONS === value.type) {
            return value.isAvailable
          }

          return undefined
        }),
      }
    })

    return {
      groupLabel,
      rows: rowsData,
    }
  })

  return (
    <BaseSection {...sectionSettings} role="table" aria-label="Product Table">
      <BaseContainer {...sectionSettings?.containerSettings}>
        {header ? (
          <PushOrg bottomSpace={10}>
            <AlignContentOrg
              horizontalAlign={{
                small: "left",
                medium: "center",
                large: "center",
              }}
            >
              <Header {...header} />
            </AlignContentOrg>
          </PushOrg>
        ) : null}

        <TableMolWrapper
          showMoreDetails={{
            text: _t("table.expandButton"),
            title: _t("table.expandButton"),
          }}
          header={{ label: label, columns: columns }}
          content={groupsData}
        />
      </BaseContainer>
    </BaseSection>
  )
}

export default TableWithContentSection
